var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_1828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.587 3.40595C10.8513 3.14166 10.9999 2.78318 10.9999 2.40937C11 2.03557 10.8515 1.67705 10.5872 1.4127C10.3229 1.14834 9.96445 0.999803 9.59064 0.999756C9.21684 0.999709 8.85832 1.14816 8.59397 1.41245L1.92097 8.08695C1.80488 8.2027 1.71902 8.34521 1.67097 8.50195L1.01047 10.6779C0.997545 10.7212 0.996569 10.7671 1.00764 10.8109C1.01872 10.8546 1.04143 10.8946 1.07337 10.9264C1.1053 10.9583 1.14528 10.981 1.18905 10.992C1.23282 11.003 1.27875 11.0019 1.32197 10.9889L3.49847 10.3289C3.65505 10.2813 3.79755 10.196 3.91347 10.0804L10.587 3.40595Z",
    stroke: "#FF7900",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5L9.5 4.5",
    stroke: "#FF7900",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_1828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReview);
export default __webpack_public_path__ + "static/media/editReview.898f6cdf04f8789e75457020828b1be6.svg";
export { ForwardRef as ReactComponent };